var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWf14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3405 2.62909L8.97858 0.789177C8.60879 0.10372 8.1894 0 7.66629 0H0.789177C0.369786 0 0 0.369786 0 0.789177V17.1003C0 17.5197 0.369786 17.8895 0.789177 17.8895H19.2108C19.6302 17.8895 20 17.5197 20 17.1003V4.10372C20 3.68433 19.6302 3.31454 19.2108 3.31454H11.4408C10.9673 3.31454 10.6516 2.99887 10.3405 2.62909Z",
    fill: "#46324E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWf14);
export default __webpack_public_path__ + "static/media/icon-wf-14.aa6b3490cb19e17d35fe35a05577728f.svg";
export { ForwardRef as ReactComponent };